import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../../axios";
import Cookies from "js-cookie";

const GetData = () => {
    var instructor_id = parseInt(Cookies.get("instructor_id"));
    const { data, isLoading, error, refetch } = useQuery({
  queryKey: ["coursesData"],
  queryFn: async () => {
    const controller = new AbortController();

    // cancel both requests after 30 seconds
    const timeoutId = setTimeout(() => {
      controller.abort();
    }, 25000);

    try {
      const [published, drafts] = await Promise.all([
        axiosInstance.get(
          `${process.env.REACT_APP_ENDPOINT}/instructors/${instructor_id}/courses`,
          { signal: controller.signal }
        ),
        axiosInstance.get(
          `${process.env.REACT_APP_ENDPOINT}/instructors/${instructor_id}/draftCourses`,
          { signal: controller.signal }
        ),
      ]);

      return {
        published: published.data,
        drafts: drafts.data,
      };
    } catch (err) {
      console.log(err);
      // if request is cancelled or timed out
      // if (err.name === "CanceledError" || err.code === "ERR_CANCELED") {
      //   return {
      //     published: [],
      //     drafts: [],
      //   };
      // }
      return {
          published: [],
          drafts: [],
        };
      throw err; // keep real API errors
    } finally {
      clearTimeout(timeoutId);
    }
  },
  staleTime: 1000 * 60 * 5, // cache for 5 minutes
});

    return {data,refetch};
};

export default GetData;